// extracted by mini-css-extract-plugin
export default {"check":"CheckBg_check__6Yc20"};